export default __webpack_public_path__ + "static/media/data-catalogs.bc8bcd3b.png";